<div class="bciti-text-select-container">
  <label>{{ label }}</label>
  <div class="bciti-select"
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid"
    (click)="showDropdown()"
    (blur)="onTouched()"
    #drop
  >
    <div class="bciti-text-select-option">
      <div class="option" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      </div>
      <div class="option" [style.color]="value?.color" *ngIf="!loading">{{ value?.label || placeholder }}</div>
      <span class="icon-caret-down"></span>
    </div>
    <app-bciti-select-list-dropdown [reference]="drop" (onClose)="onBlur($event)">
      <div class="bciti-text-select-option" *ngFor="let option of options" (click)="select(option)">
        <div class="option selectable" [style.color]="option.color">{{ option?.label }}</div>
      </div>
    </app-bciti-select-list-dropdown>
  </div>

  <div *ngIf="!disableMessages" class="messages">
    <ng-content selector="app-form-error"></ng-content>
    <ng-content selector="app-form-success"></ng-content>
  </div>
</div>

